import Lesson from './lesson'

export default class Chapter {
  readonly id: number
  readonly name: string
  readonly description: string
  readonly lessonIds: number[]
  readonly lessons: Lesson[]

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    this.description = data.description
    this.lessonIds = data.lessonIds

    if (data.lessons) {
      this.lessons = data.lessons.map(item => new Lesson(item))
    }
  }
}
